var map = {
	"./de/buttons.json": 69811,
	"./de/dialogs.json": 22663,
	"./de/elements.json": 2938,
	"./de/music.json": 43813,
	"./de/shortcuts.json": 20885,
	"./el/buttons.json": 80632,
	"./el/dialogs.json": 90566,
	"./el/elements.json": 30784,
	"./el/music.json": 76084,
	"./el/shortcuts.json": 93183,
	"./en/buttons.json": 11004,
	"./en/dialogs.json": 67367,
	"./en/elements.json": 31558,
	"./en/help/help.json": 94692,
	"./en/music.json": 56361,
	"./en/shortcuts.json": 74638,
	"./fr/buttons.json": 20252,
	"./fr/dialogs.json": 51364,
	"./fr/elements.json": 59336,
	"./fr/help/help.json": 79513,
	"./fr/music.json": 99910,
	"./fr/shortcuts.json": 2526,
	"./hr/buttons.json": 89852,
	"./hr/dialogs.json": 81410,
	"./hr/elements.json": 34165,
	"./hr/music.json": 57000,
	"./hr/shortcuts.json": 44569,
	"./it/buttons.json": 9197,
	"./it/dialogs.json": 93528,
	"./it/elements.json": 69052,
	"./it/music.json": 19892,
	"./it/shortcuts.json": 76053,
	"./sl/buttons.json": 87255,
	"./sl/dialogs.json": 60529,
	"./sl/elements.json": 66708,
	"./sl/music.json": 14177,
	"./sl/shortcuts.json": 36294,
	"./zh-Hans/buttons.json": 81304,
	"./zh-Hans/dialogs.json": 82690,
	"./zh-Hans/elements.json": 29423,
	"./zh-Hans/music.json": 25534,
	"./zh-Hans/shortcuts.json": 2900
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3631;